import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ref, set } from "firebase/database";
import { database } from "../firebase";
import { IoMdSend } from "react-icons/io";

import {
	EndApiCal,
	generateTokenapi,
	getPatientchat,
	getPhysicianchat,
	patientSendAttachmentApi,
	patientSendmessageapi,
	physicianSendAttachmentApi,
	physicianSendmessageapi,
	triggerApiCal,
} from "../network/Network";
import Pusher from "pusher-js";
import Header from "./Header";
import PageHeader from "./PageHeader";
import { Link, useLocation } from "react-router-dom";
import AgoraVideoCall from "./AgoraVideoCall";

import {
	camera,
	cancle,
	chatcurve,
	chatcurve1,
	enterchat,
	file,
	uploadfile,
	userpatient,
} from "../Constant/Index";
import Footer from "./Footer";
import VideoCall from "./Videocall";
import VideoCallComponent from "./VideoCallComponent";
import Videohandler from "./Videohandler";
import Peer from "peerjs";
import { voice } from "../Constant/Index"; // Ensure voice is the correct path to your ringtone
import ZegoCall, {
	CallButton,
	IncomingCallModal,
	VideoCalling,
} from "./ZegoCloud";
import IncomingCall from "./IncomingCall";

function ChatComponent() {
	let { state } = useLocation();
	const dispatch = useDispatch();
	const token = useSelector((state) => state?.Auth?.token);
	const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
	const allphysician = useSelector((state) => state?.Auth?.physiciandetail);
	const userDetail = useSelector((state) => state?.Auth?.users);
	const myrole = useSelector((state) => state?.Auth?.role);
	const [loading, setLoading] = useState(false);
	const [notifications, setNotifications] = useState([]);
	const [patientchat, setPatientchat] = useState([]);
	const [message, setMessage] = useState("");
	const channelName = `channel_${patientchat?.chat_id}`;
	const [getgeneratetoken, setGetgeneratetoken] = useState("");
	const eventName = "chatting";
	const [selectedFile, setSelectedFile] = useState(null);
	const [attachmentPreview, setAttachmentPreview] = useState(null);

	// Video Call UseStates
	const [peerId, setPeerId] = useState("");
	const [remotePeerId, setRemotePeerId] = useState("");
	const [callConnected, setCallConnected] = useState(false);
	const [isRinging, setIsRinging] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [showModals, setShowModals] = useState(false);

	const [acceptCalls, setAcceptCalls] = useState(false);
	const [endCalls, setEndCalls] = useState(false);
	const [isMuted, setIsMuted] = useState(false);

	const localVideoRef = useRef(null);
	const remoteVideoRef = useRef(null);
	const peerRef = useRef(null);
	const pusherRef = useRef(null);
	const audioRef = useRef(null);
	const [showAgoraCall, setShowAgoraCall] = useState(false);

	const [agoraToken, setAgoraToken] = useState("");
	const [localStream, setLocalStream] = useState(null);

	useEffect(() => {
		const fetchChatData = async () => {
			const bookingId =
				myrole == "patient"
					? orderdetail?.booking_detail?.booking_id
					: allphysician?.booking_detail?.booking_id;

			const userId =
				myrole == "patient"
					? orderdetail?.physician_detail?.physician_id
					: allphysician?.patient_detail?.patient_id;

			if (bookingId && userId && token) {
				try {
					const res =
						myrole == "patient"
							? await getPatientchat(bookingId, userId, token)
							: await getPhysicianchat(bookingId, userId, token);

					setPatientchat(res?.data);
				} catch (error) {
					// console.error("Error fetching chat:", error);
				}
			}
		};
		fetchChatData();
	}, [myrole, orderdetail, allphysician, token]);

	const handleAttachmentUpload = (event) => {
		const file = event.target.files[0];
		if (!file) return;

		setSelectedFile(file);
		setAttachmentPreview(file.name);
	};

	const cancelAttachment = () => {
		setSelectedFile(null);
		setAttachmentPreview(null);
	};

	useEffect(() => {
		if (!channelName || !eventName) return;

		const pusher = new Pusher("12d77ba5f11a38260c8b", {
			appId: "1885976",
			key: "12d77ba5f11a38260c8b",
			secret: "78157182ac7ca0d370e5",
			cluster: "mt1",
			forceTLS: true,
		});

		const channel = pusher.subscribe(channelName);

		const eventHandler = (data) => {
			console.log(data, "ajajajaja");
			// Push the new message into the chat state
			setPatientchat((prevChat) => ({
				...prevChat,
				chats: [data.message, ...prevChat?.chats],
			}));
		};

		// Bind event handler
		channel.bind(eventName, eventHandler);

		// Cleanup on component unmount
		return () => {
			channel.unbind(eventName, eventHandler);
			pusher.unsubscribe(channelName);
			pusher.disconnect();
		};
	}, [channelName, eventName, orderdetail, allphysician, token]);
	// ===================================
	// console.log("App ID:", appId);
	console.log("Channel:", channelName);
	console.log("Token:", token);

	// const sendMessage = async () => {
	//   const appointmentId =
	//     myrole == "patient"
	//       ? orderdetail?.booking_detail?.booking_id
	//       : allphysician?.booking_detail?.booking_id;

	//   const userId =
	//     myrole == "patient"
	//       ? orderdetail?.physician_detail?.physician_id
	//       : allphysician?.patient_detail?.patient_id;

	//   let data;

	//   if (myrole === "patient") {
	//     data = {
	//       appointment_id: appointmentId,
	//       physician_id: userId,
	//       message,
	//     };
	//   } else {
	//     data = {
	//       appointment_id: appointmentId,
	//       patient_id: userId,
	//       message,
	//     };
	//   }

	//   try {
	//     if (myrole == "patient") {
	//       await patientSendmessageapi(data, token);
	//     } else {
	//       await physicianSendmessageapi(data, token);
	//     }

	//     // Clear message input and update local state
	//     setMessage("");
	//     setPatientchat((prevChat) => ({
	//       ...prevChat,
	//       chats: [{ message }, ...prevChat.chats],
	//     }));
	//   } catch (error) {
	//     console.error("Error sending message:", error);
	//   }
	// };
	// Send Message Api

	const sendMessage = async () => {
		setLoading(true);
		const appointmentId =
			myrole == "patient"
				? orderdetail?.booking_detail?.booking_id
				: allphysician?.booking_detail?.booking_id;

		const userId =
			myrole == "patient"
				? orderdetail?.physician_detail?.physician_id
				: allphysician?.patient_detail?.patient_id;

		let data;

		if (myrole === "patient") {
			data = {
				appointment_id: appointmentId,
				physician_id: userId,
				message,
			};
		} else {
			data = {
				appointment_id: appointmentId,
				patient_id: userId,
				message,
			};
		}

		try {
			if (selectedFile) {
				const formData = new FormData();
				formData.append("appointment_id", appointmentId);
				formData.append("attachment", selectedFile);
				formData.append(
					myrole === "patient" ? "physician_id" : "patient_id",
					userId,
				);

				if (myrole === "patient") {
					await patientSendAttachmentApi(formData, token);
				} else {
					await physicianSendAttachmentApi(formData, token);
				}
				setSelectedFile(null);
				setAttachmentPreview(null);
				setLoading(false);
				return;
			} else {
				if (myrole === "patient") {
					await patientSendmessageapi(data, token);
				} else {
					await physicianSendmessageapi(data, token);
				}
				// Clear the message input field only
				setMessage("");
				setLoading(false);
			}
		} catch (error) {}
	};
	// 	const sendMessage = async () => {
	// 	setLoading(true);

	// 	const appointmentId =
	// 		myrole === "patient"
	// 			? orderdetail?.booking_detail?.booking_id
	// 			: allphysician?.booking_detail?.booking_id;

	// 	const userId =
	// 		myrole === "patient"
	// 			? orderdetail?.physician_detail?.physician_id
	// 			: allphysician?.patient_detail?.patient_id;

	// 	try {
	// 		// ✅ If Attachment is selected
	// 		if (selectedFile) {
	// 			const formData = new FormData();
	// 			formData.append("file", selectedFile);
	// 			formData.append("appointment_id", appointmentId);
	// 			formData.append(myrole === "patient" ? "physician_id" : "patient_id", userId);

	// 			const response = await fetch("YOUR_ATTACHMENT_API_URL", {
	// 				method: "POST",
	// 				headers: {
	// 					Authorization: `Bearer ${token}`,
	// 				},
	// 				body: formData,
	// 			});

	// 			const res = await response.json();

	// 			if (res?.data?.file_url) {
	// 				// Show file in chat
	// 				setPatientchat((prevChat) => ({
	// 					...prevChat,
	// 					chats: [
	// 						{
	// 							message: `<a href="${res.data.file_url}" target="_blank" rel="noopener noreferrer">${selectedFile.name}</a>`,
	// 							send_by: myrole,
	// 							time: new Date().toLocaleTimeString([], {
	// 								hour: "2-digit",
	// 								minute: "2-digit",
	// 							}),
	// 						},
	// 						...prevChat.chats,
	// 					],
	// 				}));
	// 			}

	// 			// Reset
	// 			setSelectedFile(null);
	// 			setAttachmentPreview(null);
	// 			setLoading(false);
	// 			return;
	// 		}

	// 		// ✅ If normal message is written
	// 		if (message.trim() !== "") {
	// 			let data;
	// 			if (myrole === "patient") {
	// 				data = {
	// 					appointment_id: appointmentId,
	// 					physician_id: userId,
	// 					message,
	// 				};
	// 				await patientSendmessageapi(data, token);
	// 			} else {
	// 				data = {
	// 					appointment_id: appointmentId,
	// 					patient_id: userId,
	// 					message,
	// 				};
	// 				await physicianSendmessageapi(data, token);
	// 			}

	// 			setPatientchat((prevChat) => ({
	// 				...prevChat,
	// 				chats: [
	// 					{
	// 						message,
	// 						send_by: myrole,
	// 						time: new Date().toLocaleTimeString([], {
	// 							hour: "2-digit",
	// 							minute: "2-digit",
	// 						}),
	// 					},
	// 					...prevChat.chats,
	// 				],
	// 			}));

	// 			setMessage("");
	// 		}
	// 	} catch (error) {
	// 		console.error("Send failed:", error);
	// 	}
	// 	setLoading(false);
	// };

	// =================

	// For Keyboard handle
	const handleKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault(); // Prevents the default action, e.g., adding a new line
			sendMessage();
		}
	};
	// =================

	// Now Videocall Functionality Start
	// "video_patient_call";
	const MyChannelName =
		myrole === "patient"
			? `video_patient_call_${userDetail?.id}`
			: `video_physician_call_${userDetail?.id}`;

	const MyEventName =
		myrole === "patient"
			? `video_patient_call_event_${userDetail?.id}`
			: `video_physician_call_event_${userDetail?.id}`;
	const videoeventName =
		myrole === "patient"
			? `video_physician_call_event_${userDetail?.id}`
			: `video_patient_call_event_${userDetail?.id}`;

	const videochannelName =
		myrole === "patient"
			? `video_physician_call_${userDetail?.id}`
			: `video_patient_call_${userDetail?.id}`;

	const Endcallchannel = "end_call";
	const Endvideocallmyevent = "end_video_call";

	// UseEffect Ringtone
	// useEffect(() => {
	// 	const peer = new Peer({ key: "peerjs", secure: true }); // Adjust with your PeerJS server key
	// 	peerRef.current = peer;

	// 	peer.on("open", (id) => {
	// 		setPeerId(id);
	// 	});

	// 	peer.on("call", (call) => {
	// 		setIsRinging(true);
	// 		// setShowModal(true);

	// 		navigator.mediaDevices
	// 			.getUserMedia({ video: true, audio: true })
	// 			.then((stream) => {
	// 				localVideoRef.current.srcObject = stream;
	// 				call.answer(stream);
	// 				call.on("stream", (remoteStream) => {
	// 					remoteVideoRef.current.srcObject = remoteStream;
	// 					setCallConnected(true);
	// 				});
	// 				call.on("close", endCall);
	// 			})
	// 			.catch((err) => console.error("Error accessing media devices:", err));
	// 	});

	// 	const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
	// 	pusherRef.current = pusher;

	// 	const channel = pusher.subscribe(MyChannelName);
	// 	channel.bind(MyEventName, (data) => {
	// 		if (data.pear_id) {
	// 			setPeerId(data.pear_id);
	// 			playRingtone();
	// 			setShowModal(true);
	// 		}
	// 	});

	// 	return () => {
	// 		peer.disconnect();
	// 		pusher.disconnect();
	// 		stopRingtone();
	// 	};
	// }, [channelName, eventName]);
	// ===================

	// UseEffect of End Call
	useEffect(() => {
		// Initialize Pusher
		const pusher = new Pusher("12d77ba5f11a38260c8b", { cluster: "mt1" });
		pusherRef.current = pusher;

		// Subscribe to the channel
		const channel = pusher.subscribe(Endcallchannel);

		// Bind the event listener
		channel.bind(Endvideocallmyevent, (data) => {
			// console.log(data, "end");
			if (data.peer_id) {
				// Update state
				setPeerId(data.peer_id);
				setCallConnected(false);
				setEndCalls(true);
			}
		});

		// Cleanup on unmount
		return () => {
			if (pusherRef.current) {
				pusherRef.current.unsubscribe(Endcallchannel);
				pusherRef.current.disconnect();
			}
		};
	}, [Endcallchannel, Endvideocallmyevent, setPeerId, setCallConnected]);
	// ===================

	// Play Ringtone Functionality
	// const playRingtone = () => {
	// 	if (audioRef.current) {
	// 		audioRef.current.pause();
	// 		audioRef.current.currentTime = 0;
	// 	}
	// 	const audio = new Audio(voice);
	// 	audio.loop = true;
	// 	audio.play().catch((err) => console.error("Failed to play ringtone:", err));
	// 	audioRef.current = audio;
	// };
	// ===========================

	// Stop ringtone
	const stopRingtone = () => {
		if (audioRef.current) {
			audioRef.current.pause();
			audioRef.current.currentTime = 0;
		}
	};
	// ==================

	// Start Call funtion
	// const startCall = () => {
	// 	navigator.mediaDevices
	// 		.getUserMedia({ video: true, audio: true })
	// 		.then((stream) => {
	// 			localVideoRef.current.srcObject = stream;
	// 			const call = peerRef.current.call(remotePeerId, stream);
	// 			call.on("stream", (remoteStream) => {
	// 				remoteVideoRef.current.srcObject = remoteStream;
	// 				setCallConnected(true);
	// 			});
	// 			call.on("close", endCall);

	// 			if (!showModal) {
	// 				triggerApiCal(
	// 					{
	// 						pear_id: peerId,
	// 						channel_name: videochannelName,
	// 						event_name: videoeventName,
	// 					},
	// 					token,
	// 				).catch((err) => console.error("Failed to notify remote user:", err));
	// 			}
	// 		})
	// 		.catch((err) => console.error("Failed to access media devices:", err));
	// };

	const startCall = (e, peerId) => {
		console.log(peerId, "sadksadk2");
		navigator.mediaDevices
			.getUserMedia({ video: true, audio: true })
			.then((stream) => {
				setLocalStream(stream); // save stream to pass to AgoraVideoCall later

				triggerApiCal(
					{
						// pear_id: peerId,
						user_id: userDetail?.id?.toString(),
						channel_name: videochannelName,
						event_name: videoeventName,
					},
					token,
				)
					.then((res) => {
						const receivedToken = res?.data?.token;
						if (receivedToken) {
							setAgoraToken(receivedToken);
							setShowAgoraCall(true);
						} else {
							console.error("Agora token not received from API");
						}
					})
					.catch((err) => {
						console.error("Failed to notify remote user:", err);
					});
			})
			.catch((err) => console.error("Failed to access media devices:", err));
	};

	// =================

	const acceptCall = () => {
		// Ensure media devices are available
		navigator.mediaDevices
			.getUserMedia({ video: true, audio: true })
			.then((stream) => {
				// Set up the local video stream
				if (localVideoRef.current) {
					localVideoRef.current.srcObject = stream;
				}

				// Initiate the call
				const call = peerRef.current.call(peerId, stream);

				// Handle incoming remote stream
				call.on("stream", (remoteStream) => {
					if (remoteVideoRef.current) {
						remoteVideoRef.current.srcObject = remoteStream;
					}
					setCallConnected(true);
				});

				// Handle call close
				call.on("close", () => {
					endCall();
				});

				// Reset modal state and stop the ringtone
				setIsRinging(false);
				setShowModal(false);
				const modalElement = document.getElementById("exampleModalToggle");
				if (modalElement) {
					const modal = new window.bootstrap.Modal(modalElement);
					modal.show();
				}
				stopRingtone();
				startCall(); // Start any post-accept call logic
			})
			.catch((error) => {
				// console.error("Error accessing media devices:", error);
				// Handle failure to access media devices
				alert(
					"Unable to access your camera or microphone. Please check permissions.",
				);
			});
	};

	// End Call Function
	const endCall = async () => {
		try {
			// Stop local video and audio tracks
			if (localVideoRef.current && localVideoRef.current.srcObject) {
				const localStream = localVideoRef.current.srcObject;
				localStream.getTracks().forEach((track) => track.stop()); // Stop each track
				localVideoRef.current.srcObject = null; // Clear the video element
			}
			if (remoteVideoRef.current && remoteVideoRef.current.srcObject) {
				stopMediaStream(remoteVideoRef.current.srcObject); // Stop remote video/audio tracks
				remoteVideoRef.current.srcObject = null; // Clear the video element
			}
			setEndCalls(true);
			// Close the peer connection if it exists
			if (peerRef.current) {
				peerRef.current.close(); // Properly close the peer connection
				peerRef.current = null; // Reset the peer reference
			}

			// Notify the remote user (optional cleanup API call)
			try {
				const response = await EndApiCal(
					{
						peer_id: peerId, // Assuming 'peerId' is properly defined
						channel_name: Endcallchannel,
						event_name: Endvideocallmyevent,
					},
					token,
				);
				// console.log("Remote user notified successfully:", response);
				setEndCalls(true); // Update the state to reflect the end of the call
			} catch (apiError) {
				// console.error("Failed to notify remote user via API:", apiError);
			}

			// Stop the remote video
			if (remoteVideoRef.current) {
				remoteVideoRef.current.srcObject = null; // Clear the remote video element
			}

			// Update the UI state
			setCallConnected(false);
		} catch (error) {
			// console.error("Error while ending the call:", error);
		}
	};
	// ===============

	const stopMediaStream = (stream) => {
		if (stream) {
			const tracks = stream.getTracks();
			tracks.forEach((track) => track.stop());
		}
	};
	// ==================================

	// Toggle mute/unmute
	const toggleMute = () => {
		if (audioRef.current) {
			const audioTrack = audioRef.current.getAudioTracks()[0];
			if (audioTrack) {
				audioTrack.enabled = !audioTrack.enabled;
				setIsMuted(!audioTrack.enabled);
			}
		}
	};
	let uuid =
		myrole == "patient"
			? orderdetail?.physician_detail?.physician_id
			: allphysician?.patient_detail?.patient_id;
	console.log("UUID for call:", uuid);

	console.log("IncomingCall component mounted for", userDetail);

	const startvideoCalling = () => {
		const roomId = `room-${Date.now()}`;
		const callRef = ref(database, `calls/${uuid}`);

		// setCallStarted(true); // 👈 Hide button immediately

		set(callRef, {
			status: "incoming",
			callerId: userDetail?.id,
			callerName: userDetail?.first_name,
			callerPhoto: userDetail?.profile_image_url,
			roomId,
			type: "one-on-one",
		});

		// Navigate to room (can use useNavigate if using react-router)
		window.location.href = `/room/${roomId}?type=one-on-one`;
	};
	// ================

	return (
		<>
			<Header />
			<PageHeader pagename="Chat" />
			<section className="chat">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="main-profile-content radius-20">
								<div className="border-bottom-chat">
									<div className="row justify-content-between align-items-center p-lg-4 p-md-2">
										<div className="col-lg-4 col-md-12">
											<div className="d-flex gap-3 align-items-center">
												{myrole == "patient" ? (
													<img
														src={
															orderdetail?.physician_detail?.profile_image_url
																? orderdetail?.physician_detail
																		?.profile_image_url
																: userpatient
														}
														className="img-fluid profie_img"
														alt=""
													/>
												) : (
													<img
														src={
															allphysician?.patient_detail?.profile_image_url
																? allphysician?.patient_detail
																		?.profile_image_url
																: userpatient
														}
														className="img-fluid profie_img"
														alt=""
													/>
												)}

												<div>
													{myrole == "patient" ? (
														<h4 className="main-heading-font mb-0 level-6">
															{orderdetail?.physician_detail?.title}
														</h4>
													) : (
														<h4 className="main-heading-font mb-0 level-6">
															{allphysician?.patient_detail?.title}
														</h4>
													)}

													<h5 className="primary-medium-font mb-0 level-8 extra-color-15">
														{myrole == "patient" ? "physician " : "patient"}
														{/* 4 mins ago */}
													</h5>
												</div>
											</div>
										</div>
										<div className="col-lg-8 col-md-12">
											<div className="row mt-2">
												<div className="col-lg-12">
													<div className="row align-items-center">
														<div className="col-lg-4 col-md-4 wrapper-top-m1">
															{/* {myrole == "patient" ? (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/user-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    View Notes
                                  </span>
                                </Link>
                              ) : (
                                <Link
                                  className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
                                  to="/physician-write-notes"
                                >
                                  <span className="bg-wrapper w-100">
                                    <img
                                      src={file}
                                      className="img-fluid pe-3"
                                      alt=""
                                    />{" "}
                                    Write Notes
                                  </span>
                                </Link>
                              )} */}
															{myrole === "patient" ? (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/user-notes"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		View Notes
																	</span>
																</Link>
															) : myrole === "physician" &&
															  allphysician?.booking_detail
																	?.appointment_status === "Past" ? (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/physician-notes"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		View Notes
																	</span>
																</Link>
															) : (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/physician-write-notes"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		Write Notes
																	</span>
																</Link>
															)}
														</div>

														<div className="col-lg-4 col-md-4 wrapper-top-m1">
															{myrole == "patient" ? (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/user-prescription"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		View Prescription
																	</span>
																</Link>
															) : myrole === "physician" &&
															  allphysician?.booking_detail
																	?.appointment_status === "Past" ? (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/physician-prescription"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		View Prescription
																	</span>
																</Link>
															) : (
																<Link
																	className="btn wrapper-btn-main w-100 log-in level-7 primary-regular-font text-decoration-none"
																	to="/write-prescription"
																>
																	<span className="bg-wrapper w-100">
																		<img
																			src={file}
																			className="img-fluid pe-3"
																			alt=""
																		/>{" "}
																		Write Prescription
																	</span>
																</Link>
															)}
														</div>

														<div className="col-lg-2 col-md-2 col-6 wrapper-top-m1">
															{orderdetail?.booking_detail
																?.appointment_status == "Current" ||
															allphysician?.booking_detail
																?.appointment_status == "Current" ? (
																<div className="d-flex align-items-center justify-content-center">
																	<div className="edit-btn chat-user">
																		{/* <Link 
                                          class="btn btn-primary"
                                          data-bs-toggle="modal"
                                          href="#exampleModalToggle"
                                          role="button"
                                    >
                                      <img
                                        src={camera}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </Link> */}
																		{/* <a
                                      className="btn btn-primary"
                                      data-bs-toggle="modal"
                                      href="#exampleModalToggle"
                                      role="button"
                                      onClick={(e) => startCall(e, peerId)}
                                    >
                                      <img
                                        src={camera}
                                        className="img-fluid"
                                        alt=""
                                      />
                                    </a> */}
																		<button
																			className="btn btn-primary"
																			// data-bs-toggle="modal"
																			// data-bs-target="#exampleModalToggle"
																			onClick={startvideoCalling}
																			// onClick={handleStartAgoraCall}
																		>
																			<img
																				src={camera}
																				className="img-fluid"
																				alt="Camera Icon"
																			/>
																		</button>
																	</div>
																</div>
															) : null}
														</div>

														<div className="col-lg-2 col-md-2 col-6 wrapper-top-m1">
															<div className="d-flex align-items-center justify-content-center">
																<div className="edit-btn chat-user">
																	{myrole == "patient" ? (
																		<Link
																			to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
																		>
																			<img
																				src={cancle}
																				className="img-fluid"
																				alt=""
																			/>
																		</Link>
																	) : (
																		<Link
																			to={`/physician-consultation-detail/${allphysician?.booking_detail?.booking_id}`}
																		>
																			<img
																				src={cancle}
																				className="img-fluid"
																				alt=""
																			/>
																		</Link>
																	)}
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="chat-main p-4">
									{myrole == "patient" ? (
										<>
											{patientchat?.chats?.map((item, cindex) => {
												return (
													<div
														key={cindex}
														className={
															item?.send_by === "physician"
																? "main-physician-massage"
																: "main-user-massage"
														}
													>
														<div
															className={
																item?.send_by === "physician"
																	? "physician-massage"
																	: "user-massage"
															}
														>
															{item?.has_attachment ? (
																// <a
																// 	href={item?.attachment}
																// 	target="_blank"
																// 	rel="noopener noreferrer"
																// >
																// 	{item?.attachment?.split("/").pop()}
																// </a>
																<a
																	href={item?.attachment}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	Media File
																</a>
															) : (
																<p>{item?.message}</p>
															)}
															<h4>{item?.time}</h4>{" "}
															{/* Correctly format the timestamp */}
															<div
																className={
																	item?.send_by === "physician"
																		? "chat-curve-img-left"
																		: "chat-curve-img-right"
																}
															>
																<img
																	src={
																		item?.send_by === "physician"
																			? chatcurve
																			: chatcurve1
																	}
																	className="img-fluid"
																	alt=""
																/>
															</div>
														</div>
													</div>
												);
											})}
										</>
									) : (
										<>
											{patientchat?.chats?.map((item, cindex) => {
												return (
													<div
														key={cindex}
														className={
															item?.send_by === "patient"
																? "main-physician-massage"
																: "main-user-massage"
														}
													>
														<div
															className={
																item?.send_by === "patient"
																	? "physician-massage"
																	: "user-massage"
															}
														>
															{item?.has_attachment ? (
																<a
																	href={item?.attachment}
																	target="_blank"
																	rel="noopener noreferrer"
																>
																	Media File
																</a>
															) : (
																<p>{item?.message}</p>
															)}
															<h4>{item?.time}</h4>{" "}
															{/* Correctly format the timestamp */}
															<div
																className={
																	item?.send_by === "patient"
																		? "chat-curve-img-left"
																		: "chat-curve-img-right"
																}
															>
																<img
																	src={
																		item?.send_by === "patient"
																			? chatcurve
																			: chatcurve1
																	}
																	className="img-fluid"
																	alt=""
																/>
															</div>
														</div>
													</div>
												);
											})}
										</>
									)}
								</div>
								{orderdetail?.booking_detail?.appointment_status == "Current" ||
								allphysician?.booking_detail?.appointment_status ==
									"Current" ? (
									<div className="chat-input">
										<div className="row align-items-center">
											<div className="col-lg-10 col-md-10 col-8">
												<div className="form-group">
													{attachmentPreview ? (
														<div className="w-100 d-flex justify-content-between align-items-center bg-light px-3 py-2 rounded">
															<span>{attachmentPreview}</span>
															<i
																className="fa fa-times text-danger"
																style={{ cursor: "pointer" }}
																onClick={cancelAttachment}
															></i>
														</div>
													) : (
														<textarea
															placeholder="Write Your Message"
															value={message}
															onChange={(e) => setMessage(e.target.value)}
															onKeyDown={handleKeyDown} // Add this to listen for Enter key
														></textarea>
													)}
												</div>
											</div>
											<div className="col-lg-1 col-md-1 col-2">
												<div className="file-upload text-end">
													<input
														type="file"
														id="attachmentInput"
														style={{ display: "none" }}
														onChange={handleAttachmentUpload}
													/>
													<img
														src={uploadfile}
														alt=""
														className="img-fluid"
														style={{
															width: "20px",
															height: "20px",
															cursor: "pointer",
														}}
														onClick={() =>
															document.getElementById("attachmentInput").click()
														}
													/>
												</div>
											</div>
											<div className="col-lg-1 col-md-1 col-2">
												<div className=" file-upload">
													<span className="loading-btn-chat loading">
														{loading ? (
															<i className="fa fa-spinner"></i>
														) : (
															<div
																onClick={sendMessage}
																style={{
																	fontSize: "20px",
																	cursor: "pointer",
																	color: "#000", // or any color you want
																}}
															>
																<IoMdSend />
															</div>
															// <img
															// 	onClick={sendMessage}
															// 	src={enterchat}
															// 	alt=""
															// 	className="img-fluid"
															// 	style={{
															// 		cursor: "pointer",
															// 		width: "21px",
															// 		height: "20px",
															// 	}}
															// />
														)}
													</span>
												</div>
											</div>
										</div>
									</div>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <VideoCall  app={appId} tok={getgeneratetoken?.token} channelName={videoChannel} eventName={"video-call"}/> */}
			{/* <VideoCall tok={getgeneratetoken?.token} userId={orderdetail?.booking_detail?.booking_id} channelName={videoChannel} /> */}

			{/* <VideoCallComponent /> */}
			{/* <Videohandler /> */}

			<div>
				{!endCalls == true ? (
					<div className="video_modal">
						<div
							className="modal fade video_modal"
							id="exampleModalToggle"
							aria-hidden="true"
							aria-labelledby="exampleModalToggleLabel"
							tabIndex="-1"
						>
							<div className="modal-dialog modal-dialog-centered modal-fullscreen">
								<div className="modal-content">
									<div className="modal-header"></div>
									<div
										className="modal-body"
										style={{
											overflow: "hidden",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										{showAgoraCall && agoraToken && (
											<div
												style={{
													width: "100%",
													height: "100%",
													display: "flex",
													justifyContent: "center",
													alignItems: "center",
												}}
											>
												{/* <AgoraVideoCall
													appId="9c8963803ecd4d59a5cb122fe886d742"
													token={agoraToken}
													// "007eJxTYLjoX/Eme2mE6t+T/uarkiev/GEWEfnW6Y+DftoLdzaVhwUKDJbJFpZmxhYGxqnJKSYpppaJpslJhkZGaakWFmYp5iZGe9IcMhoCGRmk8qeyMDJAIIgvxFCWmZKaH1+QWJKZmlcSn5yYk8PAAABlwyUh"
													channelName={videochannelName}
													preStream={localStream}
												/> */}

												{/* <ZegoCall
													userId={userDetail?.id}
													peerId={
														myrole === "patient"
															? orderdetail?.physician_detail?.physician_id
															: allphysician?.patient_detail?.patient_id
													}
												/> */}
											</div>
										)}
									</div>
									<div className="modal-footer">
										<div className="button_voice">
											<button onClick={toggleMute}>
												<i className="fa fa-microphone" aria-hidden="true"></i>
											</button>
											<button className="mike_mute">
												<i
													className="fa fa-microphone-slash"
													aria-hidden="true"
												></i>
											</button>
											<button
												onClick={() => {
													setShowAgoraCall(false);
													setAgoraToken("");
												}}
												className="concel_color"
											>
												<i className="fa fa-phone" aria-hidden="true"></i>
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : null}

				{showModal && (
					<div
						className="modal show receive_modal"
						tabIndex="-1"
						style={{ display: "block" }}
					>
						<div className="modal-dialog">
							<div className="modal-content">
								<div className="modal-header justify-content-center">
									{myrole == "patient" ? (
										<img
											src={
												orderdetail?.physician_detail?.profile_image_url
													? orderdetail?.physician_detail?.profile_image_url
													: userpatient
											}
											className="img-fluid profie1_img"
											alt=""
										/>
									) : (
										<img
											src={
												allphysician?.patient_detail?.profile_image_url
													? allphysician?.patient_detail?.profile_image_url
													: userpatient
											}
											className="img-fluid profie1_img"
											alt=""
										/>
									)}
								</div>
								<div className="modal-body text-center">
									{myrole == "patient" ? (
										<h4 className="main-heading-font mb-0 level-6">
											{orderdetail?.physician_detail?.title}
										</h4>
									) : (
										<h4 className="main-heading-font mb-0 level-6">
											{allphysician?.patient_detail?.title}
										</h4>
									)}{" "}
								</div>
								<div className="modal-footer justify-content-center">
									{/* <button
                    type="button"
                    className="btn btn-success"
                    onClick={acceptCall}
                  >
                    Accept
                  </button> */}
									<button onClick={acceptCall} className="accept_color">
										<i className="fa fa-phone" aria-hidden="true"></i>
									</button>
									<button className="concel_color">
										<i className="fa fa-phone" aria-hidden="true"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>

			{/* <div
        class="modal fade"
        id="exampleModalToggle2"
        aria-hidden="true"
        aria-labelledby="exampleModalToggleLabel2"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered modal-fullscreen">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalToggleLabel2">
                Modal 2
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              Hide this modal and show the first with the button below.
            </div>
            <div class="modal-footer">
              <button
                class="btn btn-primary"
                data-bs-target="#exampleModalToggle"
                data-bs-toggle="modal"
                data-bs-dismiss="modal"
              >
                Back to first
              </button>
            </div>
          </div>
        </div>
      </div> */}
			{/* <a
        class="btn btn-primary"
        data-bs-toggle="modal"
        href="#exampleModalToggle"
        role="button"
      >
        Open first modal
      </a> */}
			{/* <VideoCallComponent /> */}
			<IncomingCall currentUserId={userDetail?.id} />
			<Footer />
		</>
	);
}

export default ChatComponent;
